import PropTypes from 'prop-types';

import Empty from '@zenbusiness/zui/Empty';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import * as Styled from '../Footer/Footer.style';

function PartnerImage({ partnerImageUrl }) {
  if (!partnerImageUrl) {
    return <Empty noImage />;
  }

  return (
    <Styled.PartnerImage>
      <Text
        color="tertiary"
        size="xs"
      >
        From
      </Text>
      <SharedAsset
        alt="partner image"
        src={partnerImageUrl}
      />
    </Styled.PartnerImage>
  );
}

PartnerImage.propTypes = {
  partnerImageUrl: PropTypes.string
};

export default PartnerImage;
